<template>
	<v-layout row wrap fill-height>
		<v-flex >
			<v-card
			color="secondary"
			>
				<v-card-text>
					<h5 class="subheading">
						<h4 class="font-weight-medium">
						{{ position }}
						</h4>
					</h5>
					<h6 class="body-2">
						<h4 class="font-weight-light">
						{{ info }}
						</h4>
					</h6>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>

export default {
	props: ['info','position'],
  
	data () {
		return {
		
		}
	},
}
</script>

<style lang="scss" scoped>
.subheading {
	margin-bottom: 10px !important;
}
</style>

